import { z } from 'zod';
import { MoneySchema } from './common.js';
// AP Phase C1 — reusable payment-term presets per company. `netDays` drives the
// bill due date (dueDate = billDate + netDays). `discountPercent`/`discountDays`
// describe an OPTIONAL early-payment (cash) discount window (e.g. 2/10 N30 ⇒
// netDays 30, discountPercent 2, discountDays 10). A bill SNAPSHOTS the resolved
// term at create-time, so later edits to the master never change historical bills.
// Prisma Decimal(5,2) — accept either the canonical string or a coerced number.
const PercentLike = z.union([MoneySchema, z.coerce.number().min(0).max(100)]);
export const PaymentTermSchema = z.object({
    id: z.uuid(),
    companyId: z.uuid(),
    code: z.string().min(1).max(32),
    label: z.string().min(1),
    netDays: z.coerce.number().int().min(0),
    discountPercent: PercentLike.default(0),
    discountDays: z.coerce.number().int().min(0).default(0),
    isActive: z.boolean(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
// Wire shape for POST — id/companyId/timestamps are server-derived. isActive
// defaults true. The discount fields default 0 (no early-payment discount).
export const CreatePaymentTermSchema = z.object({
    code: z.string().min(1).max(32),
    label: z.string().min(1),
    netDays: z.coerce.number().int().min(0),
    discountPercent: z.coerce.number().min(0).max(100).default(0),
    discountDays: z.coerce.number().int().min(0).default(0),
    isActive: z.boolean().default(true),
});
// PATCH — all mutable fields optional. `code` is the per-company natural key and
// is intentionally NOT updatable (snapshots reference it).
export const UpdatePaymentTermSchema = CreatePaymentTermSchema.partial().omit({
    code: true,
});
//# sourceMappingURL=payment-term.js.map